import KEY from '../enums/key.js';

const selectors = {
  focusable:
    'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]',
};

class TabTrapper {
  constructor(container) {
    this.container = container;

    this.registerEventListeners();
  }

  registerEventListeners() {
    const focusableElements = this.container.querySelectorAll(
      selectors.focusable
    );

    if (focusableElements.length > 0) {
      const [firstFocusableElement] = focusableElements;
      const lastFocusableElement =
        focusableElements[focusableElements.length - 1];

      this.keyboardHandler = event => {
        if (event.key === KEY.TAB) {
          if (
            event.shiftKey &&
            document.activeElement === firstFocusableElement
          ) {
            event.preventDefault();
            lastFocusableElement.focus();
          } else if (
            !event.shiftKey &&
            document.activeElement === lastFocusableElement
          ) {
            event.preventDefault();
            firstFocusableElement.focus();
          }
        }
      };

      this.container.addEventListener('keydown', this.keyboardHandler);
    }
  }

  close() {
    this.container.removeEventListener('keydown', this.keyboardHandler);
  }
}

export default TabTrapper;
